var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"type":_vm.type,"size":_vm.size,"loading":_vm.loading},on:{"click":_vm.btnHandle}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }